<template>
  <el-dialog
    :visible.sync="visible"
    width="480px"
    custom-class="ca-auth-result"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <div slot="title" class="ca-auth-result__title">身份核验</div>
    <p class="ca-auth-result__tip">
      已向经办人手机号发送核验短信，请在新打开的认证页面中完成身份核验。
    </p>
    <p v-if="authUrl" class="ca-auth-result__reopen">
      认证页面已关闭？
      <span class="ca-auth-result__link" @click="handleOpenAuthPage">
        重新打开认证页面
      </span>
    </p>
    <div class="ca-auth-result__field">
      <span class="ca-auth-result__label">核验有效期至</span>
      <span class="ca-auth-result__value">{{ expiryText }}</span>
    </div>
    <div slot="footer" class="ca-auth-result__footer">
      <el-button type="danger" :loading="checking" @click="handleDone"> 已完成身份核验 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { authStartCaRenew } from '@/api/ca'

export default {
  name: 'CaAuthResultDialog',
  data() {
    return {
      // 弹框显隐由组件内部维护，外部通过 open() 打开
      visible: false,
      // 再次调 authStart 查询核验结果的 loading
      checking: false,
      // 当前续签订单 id
      orderId: '',
      // 认证页面链接：认证页被误关后可在弹框内重新打开
      authUrl: '',
      // 核验有效期原值（yyyyMMddHHmmss），随接口返回刷新
      expiryTime: '',
    }
  },
  computed: {
    // 核验有效期 yyyyMMddHHmmss → yyyy-MM-dd HH:mm:ss 展示
    expiryText() {
      const m = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/.exec(this.expiryTime || '')
      return m ? `${m[1]}-${m[2]}-${m[3]} ${m[4]}:${m[5]}:${m[6]}` : '--'
    },
  },
  methods: {
    /**
     * 打开确认完成弹框（移动端认证无回调，需用户手工确认）。
     * @param {{ orderId?: string, authUrl?: string, expiryTime?: string }} options
     */
    open({ orderId = '', authUrl = '', expiryTime = '' } = {}) {
      this.orderId = orderId
      this.authUrl = authUrl
      this.expiryTime = expiryTime
      this.visible = true
    },
    // 重新打开认证页面（防止用户误关认证页后无法继续核验）
    handleOpenAuthPage() {
      if (this.authUrl) {
        window.open(this.authUrl, '_blank')
      }
    },
    /**
     * 已完成身份核验：再次调 authStart 查询 5121 核验结果。
     * status=1 → 关闭弹框并通知父页面刷新订单详情；status=0 → 保持打开并 toast 状态描述。
     */
    handleDone() {
      if (this.checking) return
      this.checking = true
      authStartCaRenew({ orderId: this.orderId })
        .then((res) => {
          const d = res.data || {}
          this.authUrl = d.authUrl || this.authUrl
          this.expiryTime = d.authExpiryTime || this.expiryTime
          if (String(d.status) === '1') {
            this.visible = false
            this.$emit('success')
            return
          }
          if (d.statusDesc) {
            this.$message.warning(d.statusDesc)
          }
        })
        .catch(() => {
          // 业务报错已由 http 拦截器 toast
        })
        .finally(() => {
          this.checking = false
        })
    },
  },
}
</script>
